import { Title } from '@patternfly/react-core'
import * as React from 'react'
import styled from 'styled-components'

import { InfoTooltip } from '@app/utils/info-tooltip-icon'
import { SmallButton } from '@app/utils/styles/small-button'
import { theme } from '@app/utils/theme'

const InteractionTypeWrapper = styled.div`
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  .interaction-label-container {
    margin-top: 0.75rem;
  }
  .label {
    margin-top: 0.25rem;
    padding-right: 0.5em;
    color: ${theme.colors.gray};
  }
  .spacer {
    padding-left: 1em;
  }
  .days-after-initial-interaction-label {
    color: ${theme.colors.gray};
    padding-left: 1em;
    padding-right: 0.5em;
  }
  .days-after-initial-interaction {
    padding-left: 0.5em;
  }
  .add-follow-up-link {
    margin-left: 1em;
  }
  .link-image {
    color: ${theme.colors.active};
  }
  .link-image:hover {
    color: ${theme.colors.active};
    cursor: pointer;
  }
  .text-input-narrow {
    width: 3em;
  }
  .text-input-wide {
    width: 6em;
  }
`

interface InteractionSectionProps {
  addInteraction?: (
    event: React.MouseEvent | React.KeyboardEvent | MouseEvent,
  ) => void
  subtitle: string
  toolTip: string
  children?: React.ReactNode
}

export const InteractionSection = ({
  addInteraction,
  children,
  subtitle,
  toolTip,
}: InteractionSectionProps) => {
  return (
    <InteractionTypeWrapper>
      <Title headingLevel="h1" size="xl" className="section-title">
        {subtitle} <InfoTooltip content={toolTip} />
        {addInteraction ? (
          <SmallButton
            style={{ margin: '0 0 0.25em 1em', verticalAlign: '0.125em' }}
            variant="primary"
            onClick={addInteraction}
          >
            Add
          </SmallButton>
        ) : null}
      </Title>
      {children}
    </InteractionTypeWrapper>
  )
}
